import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import * as moment from "moment";
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { environment } from 'src/environments/environment';
import { ClipboardService } from 'ngx-clipboard';
import { log } from 'util';
import { DateAdapterService, APP_DATE_FORMATS } from 'src/app/services/date-adapter.service';
import { HttpService } from 'src/app/services/http/http.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-online-campaign',
  templateUrl: './online-campaign.component.html',
  styleUrls: ['./online-campaign.component.scss'],
  providers: [
    {
      provide: DateAdapter, useClass: DateAdapterService
    },
    {
      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }
  ]
})
export class OnlineCampaignComponent implements OnInit {
  visible = false;
  dateVisible = true;
  newCampaign: string = 'ONLINE_CAMPAIGN';
  campaign: string = 'ONLINE_CAMPAIGN';
  resultPageTemplateList = [];
  resultPageTemplate = new FormControl('', [Validators.required]);
  campaignArr = [{ value: 'Online Campaign', id: 'ONLINE_CAMPAIGN' }, { value: 'Referral', id: 'REFERRAL' }, { value: 'Offline', id: 'OFFLINE_CAMPAIGN' }];
  minDate: Date = new Date();
  //maxDate = new Date(2020, 0, 1);

  endMinDate = moment(this.minDate).add('d', 1).toDate();

  datePattern = '^[0-3]?[0-9]/[0-3]?[0-9]/(?:[0-9]{2})?[0-9]{2}$';
  campaignTypeArr = [{ value: 'MCQ', id: 'MCQ_TEST' }, { value: 'Registration', id: 'REGISTER_ONLY' }];
  Bridgelabz_walkin: boolean = false;
  // ,{value:'Referral',id:'REFERRAL'}
  todayDate: Date = new Date();
  todayDateYear: number 
  todayDateMonth: number
  todayDateDay: number 
  startDateDay : any ;
  startDateMOnth : any;
  startDateYear : any;
  extraList = ['Yes','No'];
  extra = new FormControl('', [Validators.required]);
  //templateList = ['Template 1', 'Template 2', 'Template 3'];
  templateList = [];
  testLevelArr = ['Level 1', 'Level 2', 'Level 3'];
 // campaignName = new FormControl('', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator, Validators.pattern('^[^0-9 ]{1}([A-Za-z ])+[A-Za-z]+$')]);
//  campaignName = new FormControl('', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator, Validators.pattern("^[^ ]{1}([A-Za-z0-9 ])+[A-Za-z0-9 ]+$")]);
campaignName = new FormControl('', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator, Validators.pattern("^[A-Za-z0-9 _]*[A-Za-z0-9.][A-Za-z0-9. _]*$")]);
  campaignType = new FormControl('', [Validators.required]);
  creatorName = new FormControl('', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator,Validators.pattern('^[^ ]{1}([A-Za-z ])+[A-Za-z ]+$')]);
  templateName = new FormControl('', [Validators.required]);
  url = new FormControl('');
  level = new FormControl('', [Validators.required]);
  numberOfTries = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]);
  picker1 = new FormControl('', [Validators.required]);
  startDate = new FormControl('', [Validators.required]);
  //startDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
  //endDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
  endDate = new FormControl('', [Validators.required]);
  interviewAddress = new FormControl('', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator]);
  // Validators.pattern(/^[a-zA-Z0-9\s,'-/.]*$/)
  interviewMessage = new FormControl('', [Validators.required, this.noWhitespaceValidator]);
  // Validators.pattern(".*\\S.*[a-zA-z]")
  // Validators.pattern(".*\\S.*[a-zA-z]")
  // Validators.pattern(/^[a-zA-Z0-9\s,'-/.]*$/)
  paid: boolean = false;
  type: string;
  // shortName1 = new FormControl('', [Validators.required, this.noWhitespaceValidator,Validators.pattern('^[^ ]{1}([A-Za-z0-9 ])+[A-Za-z0-9]+$')]);
  // attempts = new FormControl('',  [Validators.required ,  Validators.pattern(new RegExp(/^[1-9]*$/))]);

 // shortName1 = new FormControl('', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator,Validators.pattern('^[a-zA-Z0-9]+\s*$')]);
//  shortName1 = new FormControl('', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator, Validators.pattern("^[^ ]{1}([A-Za-z0-9 ])+[A-Za-z0-9 ]+$")]);
  shortName1 = new FormControl('', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator, Validators.pattern("^[A-Za-z0-9_]*[A-Za-z0-9.][A-Za-z0-9._]*$")]);
  attempts = new FormControl('', [Validators.required , Validators.pattern('^[1-9][0-9]*$')]);

  // /^[1-9]*$/o
  disableSubmit: boolean = false;
  hrsForUrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp(/^[0-9]*$/))]);
  //minForUrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp(/^[0-9]*$/))]);

  minForUrl = new FormControl('', [Validators.required, Validators.pattern('^[1-9][0-9]*$')]);

  hrsForResumeTime = new FormControl('', [Validators.required, Validators.pattern(new RegExp(/^[0-9]*$/))]);
  minForResumeTime = new FormControl('', [Validators.required, Validators.pattern(new RegExp(/^[0-9]*$/))]);
  passingCriteria = new FormControl('', [Validators.required, Validators.pattern(new RegExp(/^\b((100)|[1-9]\d?)\b/))]);
  template = new FormControl('',[Validators.required]);
  resumeMinutesTime: Number;
  tokenMinutesTime: Number;
  templateType: any;


  listData = [];
  shortName: string = "";
  shortNameStatus: boolean;
  campData: any = [];
  compareShortName: any;
  activeTestFormatList: any[];
  testFormatList: any;
  questionSetFormatId: any;
  shortNameList: any;
  landingLIst: any;
  additionalInformation: boolean = false;
  //minForUrl: FormControl;
  constructor(
    public dialogRef: MatDialogRef<OnlineCampaignComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private campaignService: CampaignService,
    private utilityService: UtilityService,
    private clipboardService: ClipboardService,
    private snackBarService: MatSnackBar,
    private httpService: HttpService
  ) { }

  ngOnInit() {
    console.log("hrsForUrl", this.hrsForUrl.value);
    // if(this.hrsForUrl.value === '' || this.hrsForUrl.value === 0) {
    //   console.log("hrs for url in 1", this.hrsForUrl.value);
    //   this.minForUrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp('[1-9][0-9]*'))]);
    // }
    // else {
    //   console.log("hrsForUrl in 0", this.hrsForUrl.value);
    //   this.minForUrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp(/^[0-9]*$/))]);
    // }
    this.getAllShortName();
   // this.url.disable();
    this.getCampaignData();
    this.getCollegeList("ONLINE_CAMPAIGN");
    this.getCollegeList("REFERRAL");
    this.getCollegeList('OFFLINE_CAMPAIGN');
    this.getTestFormatList();
    this.getTemplates();
  }

  getAllShortName(){
    this.campaignService.getAllShortName().subscribe(response => {
      console.log("Response short name", (response as any));
      this.shortNameList = (response as any).data;
      console.log("shortname",this.shortNameList)
    })
  }

  getCampaignData() {
    this.campaignService.getListData("ONLINE_CAMPAIGN")
      .subscribe(response => {
        console.log(response);
        this.listData = (response as any).data;
      });
  }

  // minimumResumeTime(event) {
  //   console.log("Resume time", event.value);
  //   if (event.value > 0) {
  //     console.log('Minimum resume time:', event.value);
  //     this.minForResumeTime.setValue('');
  //   }
  // }

  // getTemplates() {
  //   this.campaignService.getTemplate().subscribe(response => {
  //     console.log("Respose in getTemplates:",response);
  //   })
  // }

  getErrorMessageOfattempts() {
    return this.attempts.hasError('required') ? 'Enter number of attempts' :
     this.attempts.hasError('pattern') ? 'Invalid value for attempts' :
     '';
  }

  getErrorMessageOfExtraInfo() {
    return this.extra.hasError('required') ? 'Select extra information field' : '';
  }

  getErrorMessageOfResultPageTemplate() {
    return this.resultPageTemplate.hasError('required') ? 'Select template' : '';
  }

  getErrorMessageOfTemplate() {
    return this.template.hasError('required') ? 'Select template' : '';
  }

  getErrorMessageOfURLHrs() {
    return this.hrsForUrl.hasError('required') ? 'Enter hours for URL' :
      this.hrsForUrl.hasError('pattern') ? 'Invalid value' : '';
  }

  getErrorMessageOfURLMin() {
    return this.minForUrl.hasError('required') ? 'Enter minutes for URL' :
      this.minForUrl.hasError('pattern') ? 'Invalid value' : '';
  }

  getErrorMessageOfResumeTimeHrs() {
    return this.hrsForResumeTime.hasError('required') ? 'Enter hours for Resume' :
      this.hrsForResumeTime.hasError('pattern') ? 'Invalid value' : '';
  }

  getErrorMessageOfResumeTimeMin() {
    return this.minForResumeTime.hasError('required') ? 'Enter minutes for Resume' :
      this.minForResumeTime.hasError('pattern') ? 'Invalid value' : '';
  }

  getErrorMessageOfCampaignName() {
    return this.campaignName.hasError('required') ? 'You Must Enter A Value' :
      this.campaignName.hasError('whitespace') ? 'Enter Valid Campaign Name' :
        this.campaignName.hasError('minlength') ? 'Input must be at least 3 characters' :
        this.campaignName.hasError('pattern') ? 'Please Enter Valid Campaign Name':
          '';
  }

  getErrorMessageOfTemplateName() {
    return this.templateName.hasError('required') ? 'Template Not Selected' : '';
  }

  getErrorMessageOfCampaignType() {
    return this.campaignType.hasError('required') ? 'Select one Campaign type' : '';
  }

  getErrorMessageOfLevel() {
    return this.level.hasError('required') ? 'Format Not Selected' : '';
  }

  getErrorMessageOfCreatorName() {
    return this.creatorName.hasError('required') ? 'You Must Enter A Value' :
    this.creatorName.hasError('whitespace') ? 'Creator Name Invalid' :
      this.creatorName.hasError('minlength') ? 'Input must be at least 3 characters' :
      this.creatorName.hasError('pattern') ? 'Please Enter Valid Input' :
  
          '';
  }

  getErrorMessageOfPassingCriteria() {
    return this.passingCriteria.hasError('required') ? 'Enter Passing Criteria' :
      this.passingCriteria.hasError('pattern') ? 'Invalid value' : '';
  }

  // getErrorMessageOfURL() {
  //   return this.url.hasError('required') ? 'You must enter a value' : '';
  // }

  getErrorMessageOfTries() {
    return this.numberOfTries.hasError('required') ? 'Enter number of tries' : '';
  }

  getErrorMessageOfPaid() {
    return this.numberOfTries.hasError('required') ? 'You must enter a value' : '';

  }

  // getErrorMessageOfShortName1() {
  //   return this.shortName1.hasError('required') ? 'Enter Short Name' :
  //   this.shortName1.hasError('whitespace') ? 'Short Name Invalid' :
  //   this.shortName1.hasError('pattern') ? 'Please Enter Valid Input': '';
  // }

  getErrorMessageOfShortName1() {
    return this.shortName1.hasError('required') ? 'Enter Short Name' :
    this.shortName1.hasError('whitespace') ? 'Short Name Invalid' :
  //  this.shortName1.hasError('pattern') ? 'Please Enter Valid Input':
    this.shortName1.hasError('minlength')?'Input must be at least 3 characters':
    this.shortName1.hasError('pattern') ? 'Please Enter Valid Input': '';
  }

  getErrorMessageOfInterviewMessage() {
    return this.interviewMessage.hasError('required') ? 'Enter Interview Message' :
      this.interviewMessage.hasError('whitespace') ? 'Interview Message is invalid' : '';
  }

  getErrorMessageOfInterviewAddress() {
    return this.interviewAddress.hasError('required') ? 'Enter Interview Address' :
      this.interviewAddress.hasError('whitespace') ? 'Interview Address is invalid' :
        this.interviewAddress.hasError('minlength') ? 'Minimum 3 Letters are Required' : '';
  }

  public noWhitespaceValidator(control: FormControl) {
    console.log('value', control.value);

    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  copyUrl() {
    console.log("hello url", this.url.value);
    if (this.url.value.trim() !== '') {
      this.clipboardService.copyFromContent(this.url.value);
      this.snackBarService.open('Copied to clipboard', '', { duration: 2000 });
    }
  }

  createShortName(event) {
    console.log("Campaign Type", this.campaignType.value);
    if(this.shortName1.value != null) {
      // console.log("this.templateType.templateName:",this.templateType.templateName);
      // console.log("this.templatetype: " , this.templateType);
      if(this.shortName1.value != '' )
        this.visible = true;  
      else
        this.visible = false;
      // console.log(event);
      let tempShortName = this.shortName1.value + "";
      // tempShortName = tempShortName.trim().replace(/ +/g, "-").replace(new RegExp(/([/.\\#?%&(){},:;])/g), "-")
      //   .replace(new RegExp(/([-]{2,})/g), "-").replace(new RegExp(/ /g), '');
      tempShortName = tempShortName.trim().replace(/ +/g, "-").replace(new RegExp(/([/\\#?%&(){},:;])/g), "-")
        .replace(new RegExp(/([-]{2,})/g), "-").replace(new RegExp(/ /g), '');
  
      //let i = 0;
      // this.listData.map(campaignObject => {
      //   if (campaignObject.campaignShortName === tempShortName) {
      //     i++;
      //   }
      // });
      //if (i != 0)
        // tempShortName += i;
      //  tempShortName = tempShortName.substr(0, tempShortName.length - 1) + (Number(tempShortName.substr(tempShortName.length - 1)) + i);
      this.shortName = tempShortName;
      console.log(tempShortName);
      console.log('Short Name', this.shortName1.invalid);
      console.log('campaign Type', this.campaignType.value);
      if (this.shortName1.invalid !== true && this.campaignType.value === 'REGISTER_ONLY') {
        this.url.setValue(environment.campaignUrl1 + 'register/' + tempShortName);
      }
    console.log(this.templateType.routeUrl +"template")
      
      
      if (this.shortName1.invalid !== true && this.templateType && this.templateType.routeUrl != "economictimes" && this.templateType.routeUrl != "register" && this.campaignType.value != 'REGISTER_ONLY') {
        this.url.setValue(environment.codinClubUrl + this.templateType.routeUrl + '/' + tempShortName);
      }else{
        this.url.setValue(environment.campaignUrl1 + this.templateType.routeUrl + '/' + tempShortName);
      }
      console.log('Url:', this.url.value);
    }
  }

  submit() {
    // console.log("templateType:",this.templateType.templateId);
    // console.log("templateName:",this.templateType.templateName);
    // console.log("PassingPercentage:",Number(this.passingCriteria.value));
    // console.log("PassingPercentage type:",typeof Number(this.passingCriteria.value));
    this.resumeMinutesTime = Number(this.hrsForResumeTime.value) * 60 + Number(this.minForResumeTime.value);
    this.tokenMinutesTime = Number(this.hrsForUrl.value) * 60 + Number(this.minForUrl.value);
    // console.log("ResumeMinutesTime:",this.resumeMinutesTime);
    // console.log("ResumeMinutesTime:",typeof this.resumeMinutesTime);
    // console.log("TokenMinutesTime:",this.tokenMinutesTime);
    // console.log("TokenMinutesTime:",typeof this.tokenMinutesTime);
    // console.log("asddtional info value: " , this.extra);
    if (this.extra.value === 'Yes'){
      this.additionalInformation = true;
    } else if(this.extra.value === 'No') {
      this.additionalInformation = false;
    }
    // console.log("Time",this.hrsForResumeTime.value);
    // console.log("Type of time", typeof this.hrsForResumeTime.value);
    // console.log("start date : ", this.startDate.value);
    this.startDate.value.getFullYear()

    this.disableSubmit = true;
    console.log('CampaignType', this.campaignType.value);
    
    let requestBody = {};
    if (this.campaignType.value === 'MCQ_TEST') {
        requestBody = {
        campaignName: this.campaignName.value.trim(),
        campaignPurpose: this.campaignType.value.trim(),
        campaignShortName: this.shortName,
        campaignType: this.campaign,
        creatorName: this.creatorName.value.trim(),
        "default": true,
        endDate: moment(this.endDate.value).format("YYYY-MM-DDTHH:mm:ss"),
        interviewAddress: this.interviewAddress.value ,
        interviewMessage: this.interviewMessage.value ,
        location: "Mumbai",
        paid: this.paid,
        source: "Facebook",
        startDate: moment(this.startDate.value).format("YYYY-MM-DDTHH:mm:ss"),
        questionSetFormatId : this.questionSetFormatId,
        maxAttemptCount:  this.attempts.value,
        passingPercentage: Number(this.passingCriteria.value),
        resumeMinutesTime: this.resumeMinutesTime,
        tokenMinutesTime: this.tokenMinutesTime,
        campaignUrl: this.url.value,
        templateId: this.templateType.templateId,
        resultTemplateUrl:  this.resultPageTemplate.value === '' ? "" : this.resultPageTemplate.value.templateName,
        additionalInformation : this.additionalInformation
      };
    } else {
        requestBody = {
        campaignName: this.campaignName.value.trim(),
        campaignPurpose: this.campaignType.value.trim(),
        campaignShortName: this.shortName,
        campaignType: this.campaign,
        creatorName: this.creatorName.value.trim(),  
        "default": true,
        endDate: moment(this.endDate.value).format("YYYY-MM-DDTHH:mm:ss"),
        interviewAddress: this.interviewAddress.value ,
        interviewMessage: this.interviewMessage.value ,
      //  location: "Mumbai",
       // paid: this.paid,
       // source: "Facebook",
        startDate: moment(this.startDate.value).format("YYYY-MM-DDTHH:mm:ss"),
       // questionSetFormatId : this.questionSetFormatId,
      //  maxAttemptCount:  this.attempts.value,
      //  passingPercentage: Number(this.passingCriteria.value),
       // resumeMinutesTime: this.resumeMinutesTime,
      //  tokenMinutesTime: this.tokenMinutesTime,
        campaignUrl: this.url.value,
      //  templateId: this.templateType.templateId,
       // resultTemplateUrl:  this.resultPageTemplate.value === '' ? "" : this.resultPageTemplate.value.templateName,
      //  additionalInformation : this.additionalInformation
      };
    }
    console.log("Request body 325-------------",requestBody);
   

    this.campaignService.addOnlineCampaign(requestBody)
      .subscribe(response => {
        console.log("data after adding campaign 180---------", response);
        this.utilityService.openSnackBar("Campaign Added Successfully.");
        this.dialogRef.close("Added");

      }, (error) => {
        this.disableSubmit = false;
        this.utilityService.openSnackBar("Unable to create campaign");
        console.log(error);
      });
  }

  walkinHandler() {
    log("bridlabzwalkin event trigger")
    this.Bridgelabz_walkin = true;
  }

  onCampaignPurposeChange($event) {
    console.log("event in Campaign Purpose:",event);
    this.creatorName.reset();
    this.shortName1.reset();
    this.startDate.reset();
    this.endDate.reset();
    this.url.reset();
    this.interviewAddress.reset();
    this.interviewMessage.reset();
    this.template.reset();
    this.hrsForUrl.reset();
    this.minForUrl.reset();
    this.hrsForResumeTime.reset();
    this.minForResumeTime.reset();
    this.extra.reset();
    this.passingCriteria.reset();
    this.attempts.reset();
    this.level.reset();
    this.resultPageTemplate.reset();
  }

  onTypeChange(event) {
    console.log("event: " , event);
    
    if (event.value == "ONLINE_CAMPAIGN") {
      this.newCampaign = 'ONLINE_CAMPAIGN';
      this.campaign = 'ONLINE_CAMPAIGN';
    }
    else if (event.value == "REFERRAL") {
      this.newCampaign = 'REFERRAL';
      this.campaign = 'REFERRAL';
    }  else if (event.value == "OFFLINE_CAMPAIGN") {
      this.newCampaign = 'OFFLINE_CAMPAIGN';
      this.campaign = 'OFFLINE_CAMPAIGN';
    }
    console.log(event.value);

    // else
    //   this.newCampaign = 'Bridgelabz Walkin';
    // this.creatorName.setValue('');
    // this.shortName1.setValue('');
    // this.startDate.setValue('');
    // this.endDate.setValue('');
    // this.url.setValue('');
    this.creatorName.reset();
    this.shortName1.reset();
    this.startDate.reset();
    this.endDate.reset();
    this.url.reset();
    this.interviewAddress.reset();
    this.interviewMessage.reset();
    this.template.reset();
    this.paid = false;
    this.hrsForUrl.reset();
    this.minForUrl.reset();
    this.hrsForResumeTime.reset();
    this.minForResumeTime.reset();
  }
  getCollegeList(campaignType: String): void {
    console.log("campaigntype: ", campaignType);
    
    this.campaignService.getListData(campaignType)
      .subscribe(response => {
        console.log(response);
        this.campData.push((response as any).data);
        console.log("data at campData: ", this.campData);
  
      });
  }


  // changeShortName() {
  //   this.shortNameStatus = false;
  //   console.log('short name list',this.campData);
  // //  this.campData = this.campData[0].push(this.campData[1][1]);
  // //  console.log("after pushing new array: ", this.campData);
   
  //  for(let k=0 ; k < this.campData.length ; k++) {
  //   for (let i = 0; i < this.campData[k].length; i++) {
  //     console.log(i);
  //     console.log("data log after ---------> ",this.campData[k]);
      
  //     // for (let j = 0; j < this.campData[k][i].institution.branches.length; j++) {
  //       console.log("all shortNames" ,this.campData[k][i].campaignShortName);
  //       this.compareShortName =  this.shortName1.value
  //       this.compareShortName = this.replaceSpace(this.shortName1.value);
  //       if (this.compareShortName=== this.campData[k][i].campaignShortName) {
  //         this.shortNameStatus = true;
  //         // console.log('input----------------->', this.ShortName.value);
  //         // console.log('comparte with ----------------->', this.listData[i].institution.branches[j].shortName);
  //         // console.log('shortNameStatus------------------>', this.shortNameStatus);
  //       }
  //       // console.log('shortNameStatus------------------>', this.shortNameStatus);
  
  //     // }
  //   }
  //  }
  // }


  changeShortName() {
    this.shortNameStatus = false;
    for (let i = 0; i < this.shortNameList.length; i++) {
      if (this.shortName1.value === this.shortNameList[i]) {
        this.shortNameStatus = true;
        //  console.log('input-->', this.shortName.value);
        // console.log('comparte with -->', this.dataList[i].shortName);
        console.log('shortNameStatus-->', this.shortNameStatus);
      }
    }
  }

  getStartDate(): boolean {  
    console.log("ABCDE", this.dateVisible);
    if (this.startDate.value !== '' && this.startDate.value != null) {
      console.log("ABCDE", this.dateVisible);
      this.dateVisible = false;
      console.log("ABCDE1", this.dateVisible);
      this.todayDateYear = this.todayDate.getFullYear();
      this.todayDateMonth = this.todayDate.getMonth() + 1;
      this.todayDateDay = this.todayDate.getDate();
      this.startDateDay = this.startDate.value.getDate();
      this.startDateMOnth = this.startDate.value.getMonth() ;
      this.startDateYear = this.startDate.value.getFullYear();
      this.endMinDate = new Date(  this.startDateYear , this.startDateMOnth , this.startDateDay );
          return true;
    }
  }

  getTemplates() {
      var contentBody = { url: '/templates'}
      this.httpService.httpGet(contentBody).subscribe(response => {
        console.log('response in getTemplates:',response);
        this.templateList = (response as any).data;
        console.log("getTemplates:",this.templateList);

        this.landingLIst = this.templateList.filter(function (el) {
          return (el.templatePurpose === "LANDING_TEMPLATE");
          });

          this.resultPageTemplateList = this.templateList.filter(function (el) {
            return (el.templatePurpose === "RESULT_TEMPLATE");
            });

            console.log("resultPageTemplateList: ", this.resultPageTemplateList);
            console.log("landingLIst: ", this.landingLIst);
            
            
      })
  }

  getTestFormatList() {
    this.activeTestFormatList = []
    // this.spinnerService.show();
    const contentBody = { url: '/questionsetformats' }
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log('respose questionsetformats:', response);
      this.testFormatList = response.data;
      for (let i = 0; i < this.testFormatList.length; i++) {
        if (this.testFormatList[i].status === 'ACTIVE') {
          this.activeTestFormatList.push(this.testFormatList[i]);
        }
      }
      console.log('this.activeTestFormatList:--------->', this.activeTestFormatList);
      // console.log("activeTestFormatList", this.activeTestFormatList);
      // this.spinnerService.hide();

    }, error => {
      console.log('error after getting test format ', error);
      // this.spinnerService.hide();
      // this.openSnackBar(error.error.message)
    });
  }

  selectedLevel(id){
    console.log("selected id: ", id);
    this.questionSetFormatId = id;
  }

  // new() {
  //   console.log("hrs",this.hrsForUrl.value);
  //   if(this.hrsForUrl.value === '0') {
  //     this.minForUrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp(/^[0-9]*$/))]);
  //   }
  // }
  new() {
    console.log("hrs",this.hrsForUrl.value);
    if(this.hrsForUrl.value === '0' || this.hrsForUrl.value === '') {
    console.log("hrs in if",this.hrsForUrl.value);
    this.minForUrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp('^[1-9][0-9]*$'))]);
    }
    else{
    this.minForUrl = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]*$/)]);
    // /^[0-9]*$/
    }
    // else {
    //   this.minForUrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp('[1-9][0-9]*'))]); 
    // }
  }
}



// replaceSpace(str : string) 
  // {
  //     let s : string = ""; 
  //     for (let i = 0; i < str.length; ++i) { 
  //         if (str[i] == ' ')  
  //             s += '-'; 
  //         else
  //             s += str[i];  
  //     } 
  //     return s;   
  // }